/* eslint-disable no-console */
// Libs
import { put, takeEvery, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';

// Api
import { signInAdminAs } from 'api/admin';
import { getUserJobPosts } from 'api/jobPosts';
import changeUserStatus from 'api/user';
import { setUserJobPosts } from 'modules/JobPosts/actions';

// Actions
import {
  setUser,
  cleanUser,
  updateUserStatus,
  changeUserStatus as changeUserStatusAction,
} from 'actions/user';
import { closeModal, setModalError } from 'actions/modal';
import setLoading from 'actions/loading';
import { cleanNotifications } from 'actions/notifications';
import { signInAdminAsUser, backToAdminFromUser } from './actions';

export function* signInAdminAsUserSaga(action: any) {
  const { token } = yield select(state => state.admin);
  try {
    const user = yield signInAdminAs(action.payload, token);
    yield put(setUser(user.data));

    const userJobPosts = yield getUserJobPosts(user.data.role, user.data.token);
    yield put(setUserJobPosts(userJobPosts.data.jobs));

    yield put(push('/dashboard'));
  } catch (error) {
    console.error(error);
  }
}

export function* changeUserStatusSaga({ payload }: any) {
  const { status, userId, userRole } = payload;
  const { token } = yield select(state => state.admin);

  try {
    yield put(setLoading(true));
    yield changeUserStatus(userId, status, token);
    yield put(setLoading(false));

    yield put(updateUserStatus({ status, userId, userRole }));

    yield put(closeModal());
  } catch (error) {
    yield put(setLoading(false));
    yield put(setModalError({ error: error.response.data.error.message }));
    console.error(error.response.data.error.message);
  }
}

export function* backToAdminFromUserSaga() {
  yield put(cleanUser());
  yield put(cleanNotifications());
  yield put(push('/admin'));
}

export default function* adminSaga() {
  yield takeEvery(signInAdminAsUser, signInAdminAsUserSaga);
  yield takeEvery(backToAdminFromUser, backToAdminFromUserSaga);
  yield takeEvery(changeUserStatusAction, changeUserStatusSaga);
}
